(function ($) {
  var $ = (jQuery = $);
  const checkBreakPoint = () => {
    w = $(window).width();
    if (w <= 1080) {
      $(".my-promo")
        .not(".slick-initialized")
        .slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          autoplay: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });
    } else {
      $(".my-promo.slick-initialized").slick("unslick");
    }
  };
  $(window).resize(function () {
    checkBreakPoint();
  });
  checkBreakPoint();
})(theme.jQuery);
